<template>
  <div>
    <div class="air__utils__heading">
      <h5>Lists Widgets</h5>
    </div>
    <div class="mb-5">
      <div class="row">
        <div class="col-xl-4 col-lg-12">
          <div class="card">
            <div class="card-body">
              <air-list-1 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-5 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-8 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-11 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-14 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-17 />
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-12">
          <div class="card">
            <air-list-2 />
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-6 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-9 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-12 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-15 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-19 />
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-12">
          <div class="card">
            <div class="card-body">
              <air-list-3 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-4 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-7 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-10 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-13 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-16 />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <air-list-18 />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AirList1 from '@/components/widgets/Lists/1/index'
import AirList2 from '@/components/widgets/Lists/2/index'
import AirList3 from '@/components/widgets/Lists/3/index'
import AirList4 from '@/components/widgets/Lists/4/index'
import AirList5 from '@/components/widgets/Lists/5/index'
import AirList6 from '@/components/widgets/Lists/6/index'
import AirList7 from '@/components/widgets/Lists/7/index'
import AirList8 from '@/components/widgets/Lists/8/index'
import AirList9 from '@/components/widgets/Lists/9/index'
import AirList10 from '@/components/widgets/Lists/10/index'
import AirList11 from '@/components/widgets/Lists/11/index'
import AirList12 from '@/components/widgets/Lists/12/index'
import AirList13 from '@/components/widgets/Lists/13/index'
import AirList14 from '@/components/widgets/Lists/14/index'
import AirList15 from '@/components/widgets/Lists/15/index'
import AirList16 from '@/components/widgets/Lists/16/index'
import AirList17 from '@/components/widgets/Lists/17/index'
import AirList18 from '@/components/widgets/Lists/18/index'
import AirList19 from '@/components/widgets/Lists/19/index'

export default {
  components: {
    AirList1,
    AirList2,
    AirList3,
    AirList4,
    AirList5,
    AirList6,
    AirList7,
    AirList8,
    AirList9,
    AirList10,
    AirList11,
    AirList12,
    AirList13,
    AirList14,
    AirList15,
    AirList16,
    AirList17,
    AirList18,
    AirList19,
  },
}
</script>
